import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import CtaButton from 'components/CtaButton';
import ImageCarouselComponent from 'components/ImageCarousel';
import ArrowComponent from 'components/svgs/Arrow';
import { setTypography } from 'utils/styles/mixins';
import { mediaDesktop, mediaTablet } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

export const Wrapper = styled(motion.div)`
  margin: auto;
  padding: 5vh 2rem;
  ${mediaTablet(css`
    width: min(90vw, 800px);
  `)}
`;

export const ArticleParagraph = styled.div`
  margin-bottom: 2rem;

  p {
    margin-bottom: 2rem;
  }

  ul {
    list-style: inside;

    li {
      margin-bottom: 0.5vh;
    }
  }
`;

export const ArticleImage = styled.div<{ isLanding: boolean }>`
  margin-bottom: 2rem;
  overflow: hidden;
  width: 100%;
  height: min(90vw, 800px);

  ${({ isLanding }) =>
    isLanding &&
    css`
      height: min(70vw, 500px);
    `}
`;

export const ArticleSubtitle = styled.div`
  margin-bottom: 2rem;
  font-size: 2rem;
  font-weight: 700;
`;

export const Title = styled.div`
  ${setTypography('heading1')}
  text-align: center;
`;

export const ArticleContent = styled.div`
  /* margin: 2rem; */
  font-size: 2rem;
  min-height: calc(100vh - 70rem);
`;

export const BackButton = styled(CtaButton)`
  font-size: 2rem;
  display: flex;
  align-items: center;
  padding: 1rem 1.5rem;
  margin-bottom: 2rem;

  &:hover {
    path {
      fill: ${colors.white};
    }
  }
`;

export const Arrow = styled(ArrowComponent)`
  width: 2.6rem;
  margin: 0 0.5rem;
  transform: scaleX(-1);
`;

export const EncouragementText = styled.p`
  font-size: 2rem;
  font-weight: 700;
  text-align: center;

  margin-bottom: 2.5vh;
`;

export const SignInButton = styled(CtaButton)``;

export const EndSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  margin: 5vh auto 10vh 0;
`;

export const ArticleInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  color: ${colors.gold};
  font-size: 1.2rem;
  margin: 2rem 0;
`;

export const ImageCarousel = styled(ImageCarouselComponent)`
  width: 100%;
  height: 100%;
  margin: 4vh auto;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
`;

export const SideBySideImages = styled.div`
  display: flex;
  flex-direction: column;

  ${mediaDesktop(css`
    flex-direction: row;
  `)}
`;
